import {AfterViewInit, ChangeDetectorRef, Component} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {SharedService} from '../shared/shared.service';
import {authentication, createDirectus} from '@directus/sdk';
import {environment} from '../../environments/environment';
import {TokenStorageService} from '../shared/service/token.service';
import {ProxyDynamicService} from '../shared/service/proxy-dynamic.service';
import {distinctUntilChanged} from "rxjs";

@Component({
  selector: 'app-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements AfterViewInit {
  isCollapsed: boolean = false;
  currentPath!: string;
  isLoading: boolean = false;
  sideMenuConfig = [
    {title: 'service-card.title', path: '/service-card', selected: false, icon: 'credit-card'},
    {title: 'cash-transaction.title', path: '/cash-transaction', selected: false, icon: 'wallet-cards'},
    {title: 'top-up.title', path: '/top-up', selected: false, icon: 'moon-star'},
    {title: 'billing.title', path: '/billing', selected: false, icon: 'receipt-text'},
    {title: 'booking.title', path: '/booking', selected: false, icon: 'tickets'},
    // {title: 'sticker.title', path: '/sticker', selected: false, icon: 'ticket'},
    {
      title: 'report.title', path: '/report', selected: false, icon: 'file-chart-column-increasing', children: [
        // {title: 'report.sticker.menu-title', path: '/report/sticker', selected: false, icon: ''},
        {title: 'report.topups.menu-title', path: '/report/topups', selected: false, icon: ''},
        // {title: 'report.cancel-sticker.menu-title', path: '/report/cancel-sticker', selected: false, icon: ''},
        {title: 'report.stock.menu-title', path: '/report/stock', selected: false, icon: ''},
        {title: 'report.use-service.menu-title', path: '/report/use-service', selected: false, icon: ''},
        {title: 'report.service-card.menu-title', path: '/report/service-card', selected: false, icon: ''}
      ]
    },
    {
      title: 'master-data', path: '', selected: false, icon: 'table-properties', children: [
        {title: 'project.title', path: '/projects', selected: false, icon: ''},
        {title: 'building.title', path: '/building', selected: false, icon: ''},
        {title: 'floor.title', path: '/floor', selected: false, icon: ''},
        {title: 'owner.title', path: '/owner', selected: false, icon: ''},
        {title: 'apartment-type.title', path: '/apartment-type', selected: false, icon: ''},
        {title: 'apartment.title', path: '/apartment', selected: false, icon: ''},
        {title: 'card.title', path: '/card', selected: false, icon: ''},
        {title: 'service.title', path: '/service', selected: false, icon: ''},
        {title: 'service-package.title', path: '/service-package', selected: false, icon: ''},
        // {title: 'sticker-type.title', path: '/sticker-type', selected: false, icon: ''},
        {title: 'butler.title', path: '/butler', selected: false, icon: ''}
      ]
    },
  ]
  username: string = '';
  visible: boolean = false;

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private sharedService: SharedService,
    private tokenService: TokenStorageService,
    private service: ProxyDynamicService,
  ) {
  }

  ngAfterViewInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentPath = event.urlAfterRedirects;
        if (this.currentPath && this.currentPath !== '/') {
          this.setSelectedMenuItem(this.sideMenuConfig);
        }
        if (this.currentPath !== '/login') {        
          this.service.getUser().then((user) => {
            this.username = user['first_name'] + ' ' + user['last_name'];
          })
        }
        this.sharedService.showLoadingObservable.pipe(distinctUntilChanged()).subscribe((res) => {
          this.isLoading = res;
        });
        this.cdr.detectChanges();
      }
    });
  }

  setSelectedMenuItem(list: Array<any>) {
    for (let item of list) {
      if (item.children && item.children.length > 0) {
        this.setSelectedMenuItem(item.children);
        item.selected = item.children.findIndex((r: any) => r.selected) !== -1;
      } else {
        if (item.path && new RegExp('^' + item.path + '$').test(this.currentPath)) {
          item.selected = true;
        } else if (item.childPath && item.childPath.length) {
          for (let path of item.childPath) {
            if (path) {
              item.selected = new RegExp(path).test(this.currentPath);
            }
            if (item.selected) {
              break;
            }
          }
        } else {
          item.selected = false;
        }
      }
    }
  }

  logout() {
    this.service.signOut().then(() => {
      this.tokenService.signOut();
    });
  }

  changePass() {
    this.visible = false;
    return this.router.navigate(['/change-password']);
  }
}
